<!-- 注册页面 (type: 1公司 2成员 3公司-邀请码-入口在启翼 4公司-邀请码-入口在二维码 5邀请下级) -->
<template>
  <div class="registration">
    <!-- pc端 -->
    <div v-if="!isMobile">
      <Header></Header>
      <div class="body">
        <template v-if="Expired == false">
          <!-- pc端-成员 -->
          <memberPc v-if="type == 2" :info="info" :createBy="createBy" :companyname="companyName" :deptId="deptId"/>
          <!-- pc端-公司 -->
          <companyPc v-else-if="type == 1" :info="info" />
          <!-- pc端-公司-邀请码-入口在启翼/入口在二维码 -->
          <companyPcCode v-else-if="type == 3 || type == 4" :info="info" />
          <!-- pc端-邀请下级 -->
          <subMemberPc v-else-if="type == 5" :info="info" />
        </template>

        <div class="Expiredcss" v-if="Expired == true">
          链接过期啦！请联系管理员获取最新链接！
        </div>
      </div>
    </div>

    <!-- 手机端 -->
    <div v-if="isMobile">
      <template v-if="Expired == false">
        <!-- 手机端-成员 -->
        <memberMobile v-if="type == 2" :info="info" :createBy="createBy" :companyname="companyName" :deptId="deptId"/>
        <!-- 手机端-公司 -->
        <companyMobile v-else-if="type == 1" :info="info"/>
        <!-- 手机端-公司-邀请码-入口在启翼/入口在二维码 -->
        <companyMobileCode v-else-if="type == 3 || type == 4" :info="info" />
        <!-- 手机端-邀请下级 -->
        <subMemberMobile v-else-if="type == 5" :info="info" />
      </template>

      <div class="Expiredcss" v-if="Expired == true">
        链接过期啦！请联系管理员获取最新链接！
      </div>
    </div>
  </div>
</template>

<script>
import { authurl, authPromotionUrl } from "../../api/api";
import Header from "../../components/headerWhitOutUser/index.vue";
import memberPc from "./components/memberPc.vue";
import companyPc from "./components/companyPc.vue";
import companyPcCode from "./components/companyPcCode.vue";
import subMemberPc from "./components/subMemberPc.vue";

import memberMobile from "./components/memberMobile.vue";
import companyMobile from "./components/companyMobile.vue";
import companyMobileCode from "./components/companyMobileCode.vue";
import subMemberMobile from "./components/subMemberMobile.vue";
export default {
  name: "registration",
  components: {
    Header,
    memberPc,
    companyPc,
    companyPcCode,
    subMemberPc,
    
    memberMobile,
    companyMobile,
    companyMobileCode,
    subMemberMobile,
  },
  data() {
    return {
      isMobile: false, // 是否为手机端
      type: null, // 类型
      Encrypted: null, // 校验的密码
      Expired: null, // 链接是否过期
      createBy: null,
      companyName: "",
      deptId: "",
      // 通过链接查询到的信息
      info: null
    };
  },
  mounted() {
    this.judgeMobile();
    console.log(this.$route.params)
    this.type = this.$route.params.type;
    this.Encrypted = this.$route.params.Encrypted;
    if(this.type == 3) {
      // 通过邀请码进入时 不需要校验是否过期
      this.Expired = false;
      this.info = {
        type: this.type
      };
    } else if(this.type == 4) {
      // 通过扫码进入时 不需要校验是否过期 需要把网址上的邀请码解析出来
      this.Expired = false;
      this.info = {
        promotionNum: this.Encrypted,
        type: this.type
      };
    } else if(this.type == 5) {
      // 邀请下级时 单独校验有效期
      this.checkPromotionExpired();
    } else {
      this.checkexpired();
    }
  },
  methods: {
    judgeMobile() {
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        //移动端
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    // 检查推广人员的链接是否过期
    async checkPromotionExpired() {
      let res = await authPromotionUrl({ userManagement: this.Encrypted })
      console.log('authurl: ', res)
      if (res.code == 200) {
        this.info = res.data;
        this.Expired = false;
      } else {
        this.type = null;
        this.Expired = true;
      }
    },
    // 检查链接是否过期
    async checkexpired() {
      let res = await authurl({ userManagement: this.Encrypted })
      console.log('authurl: ', res)
      if (res.code == 200) {
        this.info = res.data
        this.companyName = res.data.companyName || res.data.unitUse;
        this.createBy = res.data.createBy;
        this.deptId = res.data.deptId;
        this.Expired = false;
      } else {
        this.type = null;
        this.Expired = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.registration {
  .body {
    width: 100%;
    height: calc(100vh - 3.75rem);
    background: url("../../assets/IMG/registration/bg.png");
    background-size: 100% 100%;
    position: relative;
    .illustration {
      position: absolute;
      right: 0rem;
      bottom: 3.125rem;
      width: 25%;
      height: 35%;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .bottom_line {
      margin-top: 10%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #b7282d;
      .line {
        margin: 0 1.25rem;
        width: 40%;
        border-bottom: 0.0625rem solid #b7282d;
      }
    }
  }

  .Expiredcss {
    font-size: 1rem;
    width: 100%;
    height: 70%;
    display: flex;
    justify-content: center;
    font-weight: 600;
    padding-top: 15%;
    box-sizing: border-box;
    color: rgba($color: #b7282d, $alpha: 0.6);
  }
}
</style>